<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="filteredPlaces"
      :pageCount="numberOfPages"
      :items-per-page="itemsPerPage"
      class="elevation-2 striped"
      v-model="selectedRows"
      :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
        'items-per-page-text': `${perPageText}`,
      }"
      :loading="loadTable"
      :loading-text="$t('common.loadingText')"
    >
      <template v-slot:body.prepend>
        <tr>
          <td class="d-inline-block d-sm-table-cell">
            <v-text-field
              v-model="placeName"
              type="text"
              :label="$t('_place.name')"
            ></v-text-field>
          </td>
          <td class="d-inline-block d-sm-table-cell">
            <v-text-field
              v-model="address"
              type="text"
              :label="$t('_place.address')"
            ></v-text-field>
          </td>
          <td class="d-inline-block d-sm-table-cell">
            <v-text-field
              v-model="countyName"
              type="text"
              :label="$t('_place.county')"
            ></v-text-field>
          </td>
          <td class="d-inline-block d-sm-table-cell">
            <v-text-field
              v-model="neighborhoodName"
              type="text"
              :label="$t('_place.neighborhood')"
            ></v-text-field>
          </td>
          <td class="d-inline-block d-sm-table-cell">
            <v-text-field
              v-model="lat"
              type="number"
              :label="$t('_place.lat')"
            ></v-text-field>
          </td>
          <td class="d-inline-block d-sm-table-cell">
            <v-text-field
              v-model="lon"
              type="number"
              :label="$t('_place.lon')"
            ></v-text-field>
          </td>
          <td class="d-inline-block d-sm-table-cell">
            <v-text-field
              v-model="phone"
              type="text"
              :label="$t('_place.phone')"
            ></v-text-field>
          </td>
        </tr>
      </template>

      <template v-slot:item="{ item }">
        <tr
          :style="
            selectedRows.indexOf(item.id) > -1 ? 'background-color:#82DAC0' : ''
          "
          @click="rowClick(item)"
        >
          <td>{{ item.name }}</td>
          <td>{{ item.address }}</td>
          <td>{{ item.countyName }}</td>
          <td>{{ item.neighborhoodName }}</td>
          <td>{{ item.lat.toFixed(6) }}</td>
          <td>{{ item.lon.toFixed(6) }}</td>
          <td>{{ phoneFormat(item.phone) }}</td>
          <td align="right">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon
                    small
                    @click="onUploadButtonClick(item)"
                    color="orange"
                  >
                    file_upload
                  </v-icon>
                </v-btn>
                <!-- accept="application/xml, application/zip" -->
                <input
                  id="file"
                  ref="uploader"
                  type="file"
                  style="display: none"
                  multiple
                  @change="onFileChanged"
                />
              </template>
              <span>{{ $t("actions.uploadPhoto") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon small @click="itemPhoto(item)" color="blue">
                    photo_camera
                  </v-icon></v-btn
                >
              </template>
              <span>{{ $t("actions.showPhoto") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon small @click="editItem(item)" color="green">
                    mdi-pencil
                  </v-icon></v-btn
                >
              </template>
              <span>{{ $t("actions.edit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on">
                  <v-icon small @click="deleteItem(item)" color="error">
                    mdi-delete
                  </v-icon></v-btn
                >
              </template>
              <span>{{ $t("actions.delete") }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>

      <template v-slot:no-data>
        <v-card-text>{{ $t("common.dataNotFound") }}</v-card-text>
      </template>
    </v-data-table>
    <v-dialog
      width="1000"
      :retain-focus="false"
      v-model="showPhoto"
      v-if="selectedItem != null && selectedItem.placeAssets.length != 0"
    >
      <v-card max-width="1000" dark>
        <v-card-title
          >{{ selectedItem.name }}
          <v-spacer></v-spacer>
          <v-btn right small color="error" dark @click="deletePhoto()">
            <v-icon dark left>delete</v-icon>
            {{ "FOTOĞRAFI SİL" }}
          </v-btn>
        </v-card-title>
        <!-- <vueper-slides fixedHeight="500px">
            <vueper-slide
            style="background-size: 100% auto; background-position: center; background-repeat: no-repeat;"
              v-for="(asset, i) in selectedItem.placeAssets"
              :key="i"
              :image="asset.photoUrl"
              :title="selectedItem.name"
            />
          </vueper-slides> -->
        <v-carousel show-arrows-on-hover v-model="currentIndex" height="500">
          <v-carousel-item
            v-for="(asset, i) in selectedItem.placeAssets"
            :key="i"
          >
            <v-img :src="asset.photoUrl" contain max-height="450"/>
          </v-carousel-item>
        </v-carousel>
      </v-card>
    </v-dialog>

    <place-dialog-button
      :dialog.sync="dialog"
      :editedItem="editedItem"
      :editedIndex="editedIndex"
      :counties="counties"
      :neighborhoods="neighborhoods"
      @confirmed="onConfirmed"
      @cancelled="onCancelled"
    />
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      elevation="24"
      :color="snackColor"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
    >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Kapat
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import PlaceDialogButton from "@/pages/PlacesPage/PlaceDialogButton.vue";
import Dialog from "primevue/dialog";
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    items: Array,
    headers: Array,
    pagePlaceDialogButton: Number,
    numberOfPages: Number,
    itemsPerPage: Number,
    counties: Array,
    neighborhoods: Array,
    groupId: String,
  },
  components: {
    Dialog,
    VueperSlides,
    VueperSlide,
    PlaceDialogButton,
  },
  data() {
    return {
      currentIndex: 0,
      currentAssetId: "",
      placeName: "",
      address: "",
      countyName: "",
      neighborhoodName: "",
      lat: "",
      lon: "",
      phone: "",
      dialog: false,
      showPhoto: false,
      dialogDelete: false,
      desserts: [],
      editedIndex: -1,
      editedItem: {
        name: "",
        address: "",
        countyCode: -1,
        neighborhoodCode: "",
        phone: "",
        lat: "",
        lon: "",
        placeAssets: [],
      },
      defaultItem: {
        name: "",
        address: "",
        phone: "",
        lat: "",
        lon: "",
      },
      snackbar: false,
      snackColor: "",
      snackText: "",
      timeout: 3000,
      x: "",
      y: "",
      mode: "",
      selectedItem: null,
      selectedId: -1,
      selectedRows: [],
      loadTable: true,
    };
  },
  watch: {
    "$route.params.place": {
      handler: function (name) {
        (this.placeName = ""),
          (this.address = ""),
          (this.countyName = ""),
          (this.neighborhoodName = ""),
          (this.lat = ""),
          (this.lon = ""),
          (this.phone = "");
        this.loadTable = true;
      },
      deep: true,
      immediate: true,
    },
  },

  computed: {
    ...mapGetters({ language: "app/language" }),

    filteredPlaces() {
      this.loadTable = false;

      let conditions = [];

      if (this.placeName) {
        conditions.push(this.filterPlaceName);
      }
      if (this.address) {
        conditions.push(this.filterAddress);
      }
      if (this.countyName) {
        conditions.push(this.filterCountyName);
      }
      if (this.neighborhoodName) {
        conditions.push(this.filterNeighborhoodName);
      }
      if (this.lat) {
        conditions.push(this.filterLat);
      }
      if (this.lon) {
        conditions.push(this.filterLon);
      }
      if (this.phone) {
        conditions.push(this.filterPhone);
      }

      if (conditions.length > 0) {
        return this.items.filter((item) => {
          return conditions.every((condition) => {
            return condition(item);
          });
        });
      }

      return this.items;
    },
    perPageText() {
      if (this.language == "en_US") {
        return "Rows per page:";
      }
      return "Sayfa başına satır:";
    },
  },
  methods: {
    filterPlaceName(item) {
      return item.name.toLowerCase().includes(this.placeName.toLowerCase());
    },
    filterAddress(item) {
      return item.address.toLowerCase().includes(this.address.toLowerCase());
    },
    filterCountyName(item) {
      return item.countyName
        .toLowerCase()
        .includes(this.countyName.toLowerCase());
    },
    filterNeighborhoodName(item) {
      return item.neighborhoodName
        .toLowerCase()
        .includes(this.neighborhoodName.toLowerCase());
    },
    filterLat(item) {
      return item.lat.toString().toLowerCase().includes(this.lat.toLowerCase());
    },
    filterLon(item) {
      return item.lon.toString().toLowerCase().includes(this.lon.toLowerCase());
    },
    filterPhone(item) {
      return item.phone.toLowerCase().includes(this.phone.toLowerCase());
    },
    onConfirmed(editedItem) {
      // hide a dialog
      this.dialog = false;
      this.$emit("fileUploaded");
      // save a user and refresh a table
    },
    onCancelled() {
      // hide a dialog
      this.dialog = false;
    },
    ...mapActions({
      removePlace: "places/remove",
      removeAsset: "places/removeAsset",
      uploadAsset: "places/uploadPlaceAsset",
    }),
    async deleteItem(item) {
      var self = this;
      self.loading = true;
      self
        .$swal({
          title: "Kaydı silmek istediğinizden emin misiniz ?",
          text: "Tekrar geri alamayacaksınız.",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Sil",
          cancelButtonText: "Vazgeç",
          confirmButtonColor: "#ff7674",
          cancelButtonColor: "#41b882",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        })
        .then(async function (isConfirm) {
          if (isConfirm.value) {
            self.loading = true;
            try {
              await self.removePlace({
                item: item,
              });
              self.snackbar = true;
              self.snackColor = "success";
              self.snackText = "Kayıt silindi";
              self.x = "center";
              self.y = "bottom";
              self.timeout = 3000;
            } catch (e) {
              self.snackbar = true;
              self.snackColor = "error";
              self.snackText = "Kayıt silinemedi";
              self.x = "center";
              self.y = "bottom";
              self.timeout = 3000;

              console.error(e);
            }
          } else {
            self.loading = false;
          }
        });
    },
    async deletePhoto() {
      var self = this;
      self.loading = true;
      self
        .$swal({
          title: "Fotoğrafı silmek istediğinizden emin misiniz ?",
          text: "Tekrar geri alamayacaksınız.",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Sil",
          cancelButtonText: "Vazgeç",
          cancelButtonColor: "#41b882",
          confirmButtonColor: "#ff7674",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        })
        .then(async function (isConfirm) {
          if (isConfirm.value) {
            self.loading = true;
            try {
              await self.removeAsset({
                placeId: self.selectedItem.id,
                assetId: self.selectedItem.placeAssets[self.currentIndex].id,
              });
              self.snackbar = true;
              self.snackColor = "success";
              self.snackText = "Kayıt silindi";
              self.x = "center";
              self.y = "bottom";
              self.timeout = 3000;
              self.showPhoto = false;

              self.$emit("fileUploaded");
              self.selectedItem.placeAssets.splice(self.currentIndex, 1);
              self.showPhoto = true;
            } catch (e) {
              self.snackbar = true;
              self.snackColor = "error";
              self.snackText = "Kayıt silinemedi";
              self.x = "center";
              self.y = "bottom";
              self.timeout = 3000;

              console.error(e);
            }
          } else {
            self.loading = false;
          }
        });
    },
    async editItem(item) {
      console.log("itemmmmmmmmm", item);
      this.editedIndex = this.filteredPlaces.indexOf(item);
      console.log("editedIndex", this.editedIndex);
      this.editedItem = Object.assign({}, item);
      this.editedItem.phone = this.phoneFormat(this.editedItem.phone);
      this.dialog = true;
    },
    async itemPhoto(item) {
      console.log("photoitem", item);
      this.selectedItem = { ...item };
      if (this.selectedItem.placeAssets.length == 0) {
        // this.$swal({
        //   title: "Fotoğraf bulunamadı!",
        //   // text: "Fotoğraf bulunamadı!",
        //   type: "warning",
        //   confirmButtonText: "Tamam",
        //   confirmButtonColor: "#41b882",
        //   showLoaderOnConfirm: true,
        // });
        this.snackbar = true;
        this.snackColor = "warning";
        this.snackText = "Fotoğraf bulunamadı!";
        this.y = "bottom";
        this.x = "right";
        this.mode = "multi-line";
      }
      this.showPhoto = true;
    },
    async onUploadButtonClick(item) {
      // this.$refs.uploader.click();
      this.selectedItem = { ...item };
      document.getElementById("file").click()
    },
    async onFileChanged(e) {
      // let files = this.$refs.uploader.files;
      let files = e.target.files;
      for (let file of files) {
        console.log(file);
        console.log(file.type.split("/")[0]);

        if (
          file.type.split("/")[0] === "image" &&
          file.name.length > 2
          //&& file.size < 150000
        ) {
          console.log(file);
          console.log(this.selectedItem.id);
          try {
            await this.uploadAsset({
              id: this.selectedItem.id,
              file: file,
            });
            this.snackbar = true;
            this.snackColor = "success";
            this.snackText = "Fotoğraf yüklendi!";
            this.y = "bottom";
            this.x = "right";
            this.mode = "multi-line";
          } catch (e) {
            this.snackbar = true;
            this.snackColor = "error";
            this.snackText = "Fotoğraf yüklenemedi!";
            this.y = "bottom";
            this.x = "right";
            this.mode = "multi-line";
            console.error(e);
          }
        } else {
          console.log("invalid file.");
          this.snackbar = true;
          this.snackColor = "error";
          this.snackText = "Dosya formatı geçersiz!";
          this.y = "bottom";
          this.x = "right";
          this.mode = "multi-line";
        }

        //let file = files[i];
      }
      // this.$refs.uploader.value = "";
      this.$emit("fileUploaded");
    },
    phoneFormat(phone_number) {
      return phone_number
        .replace(/[^0-9]/g, "")
        .replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, "+90 ($1) $2 $3 $4");
    },
    async rowClick(item, row) {
      console.log("row clicked");
      console.log(item.id);
      // row.select(true);
      this.selectedId = item.name;
      this.toggleSelection(item);
      console.log("rowclickkkk");
    },
    async toggleSelection(item) {
      if (this.selectedRows.includes(item.id)) {
        console.log(this.selectedRows);
        this.selectedRows = this.selectedRows.filter(
          (selectedKeyID) => selectedKeyID !== item.id
        );
        this.$emit("placeReClick");
      } else if (this.selectedRows.length == 0) {
        this.selectedRows.push(item.id);
        this.$emit("placeClick", item);
      } else if (
        !this.selectedRows.includes(item.id) &&
        this.selectedRows.length == 1
      ) {
        this.selectedRows.pop();
        this.selectedRows.push(item.id);
        this.$emit("placeClick", item);
      }
    },
  },
};
</script>

<style scoped>
::v-deep tr.v-data-table__selected {
  background: #82DAC0 !important;
}
/* .v-text-field {
  width: 120px;
  height: 62px;
}
tr {
  height: 10px !important;
} */
</style>